<template>
    <div class="nutrition-components-container" v-if="nutritionData.length > 0">
        <div 
            v-for="item in nutritionData" 
            class="nutrition-components-component" 
            :key="item.NutritionComponentId">
            <div>{{ item.Amount }}</div>
            <div>{{ item.ShortName.toLowerCase() }}</div>
        </div>
    </div>
</template>

<script>
import menuItemMixin from '../../../js/mixins/menuItemMixin';

export default {
    name: 'nutrition-components',
    mixins: [menuItemMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        limit: {
            type: Number,
            default: 4
        }
    },
    computed: {
        nutritionData() {
            const nutrition = this.getNutrition(this.item);
            return this.limit ? nutrition.slice(0, this.limit) : nutrition;
        },
    }
}
</script>

<style scoped>
.nutrition-components-container {
    display: flex;
    flex-direction: row;
    gap: 8px;
    font-size: 12px;
}

.nutrition-components-component {
    padding-right: 8px;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 4px;
    color: #52545B;
    border-right: 1px solid #E1E1E2;
    white-space: nowrap;
}

.nutrition-components-component:last-child {
    border-right: none;
    padding-right: 0;
}
</style>